<template>
  <div class="form form_w460">
    <div class="form__head">
      <div class="form__title form__title_white mb10">
        {{$t("forms.areUSure")}}
        <button
          type="reset"
          class="form__address-close js-btn-close"
          @click="close"
        >
          <img src="@/assets/images/close.svg" width="24px" alt />
        </button>
      </div>
    </div>

    <div class="form__content">
      <div class="form-item">
        <p
          class="form-item__text form-item__text_tac form-item__text_black form-item__text_foz20 mb40"
        >{{$t("forms.areUSureText")}}</p>
      </div>

      <div class="form-item buttons buttons_mt">
        <button
          class="btn btn_upper btn_red js-btn-cancel"
          @click="close"
          type="reset"
        >{{$t('buttons.cancel')}}</button>

        <button
          class="btn btn_upper js-btn-accept"
          @click="accept"
          type="reset"
        >{{$t('buttons.continue')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "delete-modal",
  methods: {
    close() {
      this.$emit("close");
    },
    accept() {
      this.$emit("accept");
    }
  }
};
</script>

<style lang="scss" scoped>
.form__address-close {
  background: transparent;
  border: none;
  position: absolute;
  right: 0;
  padding: 0;
  outline: none;
  cursor: pointer;
}
</style>